import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface ExclusiveDealsCardProps {
  fromColor?: string;
  toColor?: string;
  logo: string;
  bonusPercentage?: number;
  upto?: number;
  allowedCountries: string;
  country: string;
  index?: number;
  freespins?: boolean;
  flag?: string | null;
  refURL: string;
}

const ExclusiveDealsCard: React.FC<ExclusiveDealsCardProps> = ({
  fromColor = "rgba(252,176,69,1)",
  toColor = "rgba(245,101,101,1)",
  logo,
  bonusPercentage,
  upto,
  index,
  freespins = false,
  flag,
  allowedCountries,
  country,
  refURL,
}) => {
  const [allowed, setAllowed] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (country) {
      const allowedCountriesArray = allowedCountries
        .split(",")
        .map((c) => c.trim().toLowerCase());
      setAllowed(allowedCountriesArray.includes(country.toLowerCase()));
    }
  }, [allowedCountries, country]);

  return (
    <div
      key={index}
      className="h-[20rem] lg:h-[25rem] w-[18rem] rounded-[40px] flex flex-col p-3
       justify-center items-center lg:transition-transform duration-300 ease-in-out lg:transform lg:hover:scale-105"
      style={{
        background: `radial-gradient(circle, ${fromColor} 0%, ${toColor} 100%)`,
      }}
    >
      <div>
        <img
          alt="Logo"
          src={logo}
          className="object-contain h-16 md:h-16 lg:h-16 w-full my-auto"
        />
      </div>

      <div className="my-auto flex flex-col items-center justify-center">
        <h2 className="my-auto lg:text-[2rem] font-bold text-center">
          {bonusPercentage} Bonus
        </h2>
        <h2 className="my-2 lg:text-[1.3rem] font-semibold text-center">
          {t("upto")} {upto}
        </h2>
        {freespins && (
          <h2 className="my-auto lg:text-[2rem] font-bold text-center">
            + FREE SPINS
          </h2>
        )}
      </div>

      <h2 className="flex font-bold text-sm text-center">
        {flag && (
          <img alt="Flag" src={flag} className="mr-3 w-[20px] h-[20px]" />
        )}
        {!allowed ? "You Cannot Play" : "You Can Play"}
      </h2>
      <button
        disabled={!allowed}
        onClick={() => window.open(refURL, "_blank")}
        className={`text-xs text-center lg:text-[1.3rem] py-[1rem] w-[90%] rounded-full bg-white text-black text-center my-auto select-none hover:animate-shake ${
          !allowed ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        {t("receive_bonus")}
      </button>
    </div>
  );
};

export default ExclusiveDealsCard;
